export default __webpack_public_path__ + "static/media/eyeSee.02bd2456.svg";